const NotFound = () => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <section className="content-list">
          <div className="no-access">
            <h1>404</h1>
            <h2>Page not found</h2>
            <p>
              The page you are looking for doesn’t exist. Please, use navigation
              bar to continue.
            </p>
          </div>
        </section>
      </section>
    </main>
  );
};

export default NotFound;
